module.exports = __webpack_public_path__ + "img/site-0-3.5569fb98.svg";